import { EntityQuery } from 'breeze-client';

const baseQuery = EntityQuery.from('WorkspaceInfos');

export const organisationWorkspaceInfoQueries = {
  selectAll: baseQuery
};
